<div class="container">
  <span class="title">{{title}}</span>
  <div class="input-wrapper">
    <input [value]="value" [placeholder]="placeholder || ('Common.Input.placeholder' | translate)" [type]="inputType"
      [name]="name" [class]="className" (input)="onInputChange($event)" (blur)="onTouched()" [disabled]="disabled"
      class="input" />
    <button class="btn" type="button" (click)="showPassword()">
      <app-eye></app-eye>
    </button>
  </div>
  <span class="error" *ngIf="error">{{getTranslatedError()}}</span>
</div>